import { render } from "./LoginLinks.vue?vue&type=template&id=9a2a0734&scoped=true"
import script from "./LoginLinks.vue?vue&type=script&lang=js"
export * from "./LoginLinks.vue?vue&type=script&lang=js"

import "./LoginLinks.vue?vue&type=style&index=0&id=9a2a0734&scoped=true&lang=css"

import exportComponent from "D:\\TeamCity\\BuildAgent2\\work\\1bfd74eb4d5fb108\\FamilyPortalApp\\familyportal-app\\src\\familyportal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a2a0734"]])

export default __exports__